"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BQ = void 0;
exports.BQ = {
    numericCode: '535',
    alpha2Code: 'BQ',
    alpha3Code: 'BES',
    englishName: {
        short: 'Bonaire, Sint Eustatius and Saba',
        full: 'Bonaire, Sint Eustatius and Saba',
    },
    names: {
        full: {
            en: 'British Antarctic Territory',
            fr: "Antarctique, Territoire britannique de l'",
            nl: 'Bonaire, Sint Eustatius en Saba',
            '': 'Boneiru, Sint Eustatius y Saba',
        },
        short: {
            en: 'British Antarctic Territory',
            fr: "Antarctique, Territoire britannique de l'",
            nl: 'Bonaire, Sint Eustatius en Saba',
            '': 'Boneiru, Sint Eustatius y Saba',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'nl',
            languageAlpha3Code: 'nld',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: '',
            languageAlpha3Code: 'pap',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
    ],
    subdivisions: {
        'BQ-BO': {
            numericCode: '535',
            code: 'BQ-BO',
            category: {
                id: '272',
                names: {
                    en: {
                        singular: 'special municipality',
                        plural: 'special municipalities',
                    },
                    fr: {
                        singular: 'commune speciale',
                        plural: '',
                    },
                    nl: {
                        singular: 'bijzondere gemeente',
                        plural: '',
                    },
                    '': {
                        singular: 'munisipio spesial',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Bonaire',
                nl: 'Bonaire',
                '': 'Boneiru',
            },
        },
        'BQ-SA': {
            numericCode: '535',
            code: 'BQ-SA',
            category: {
                id: '272',
                names: {
                    en: {
                        singular: 'special municipality',
                        plural: 'special municipalities',
                    },
                    fr: {
                        singular: 'commune speciale',
                        plural: '',
                    },
                    nl: {
                        singular: 'bijzondere gemeente',
                        plural: '',
                    },
                    '': {
                        singular: 'munisipio spesial',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Saba',
                nl: 'Saba',
                '': 'Saba',
            },
        },
        'BQ-SE': {
            numericCode: '535',
            code: 'BQ-SE',
            category: {
                id: '272',
                names: {
                    en: {
                        singular: 'special municipality',
                        plural: 'special municipalities',
                    },
                    fr: {
                        singular: 'commune speciale',
                        plural: '',
                    },
                    nl: {
                        singular: 'bijzondere gemeente',
                        plural: '',
                    },
                    '': {
                        singular: 'munisipio spesial',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Sint Eustatius',
                nl: 'Sint Eustatius',
                '': 'Sint Eustatius',
            },
        },
    },
};
//# sourceMappingURL=data:application/json;base64,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